<template>

<div>
    <chat-window
        v-if="socketChat!=null"
        :current-user-id="currentUserId"
        :rooms="rooms"
        :messages="messages"
        :messages-loaded="messagesLoaded"
        :rooms-loaded="roomLoaded"
        :loading-rooms="loadingRooms"
        :single-room="true"

        @send-message="sendMessage"
        @fetch-messages="fetchMessages"
        @open-file="openFile"
        @send-message-reaction="sendMessageReaction"
        @edit-message="editMessage"
        @delete-message="deleteMessage"
    />
  </div>
</template>

<script>
  import ChatWindow from 'vue-advanced-chat'
  import 'vue-advanced-chat/dist/vue-advanced-chat.css'
  import { parseTimestamp, isSameDay } from '@/utils/dates'
  import chatService from '@/services/chat.service.js'
  import { io } from "socket.io-client";
  import {WS_CHAT, WS_CHAT_PATH} from "@/services/base-url.js"

  var crService = new chatService();
  var ws_chat_url = WS_CHAT;
  var ws_chat_path = WS_CHAT_PATH;
  export default {
    components: {
      ChatWindow
    },
    data() {
      return {
        rooms: [],
        currentRoom:null,
        roomLoaded:false,
        messages: [],
        messagesLoaded: false,
        currentUserId: "",
        loadingRooms: true,
        pageMessage:0,
        messagesPerPage:10,
        startMessages: null,
        endMessages: null,
        numberOfMessageLoad:0,
        socketChat:null,
      }     
    },
    computed:{
        socket: function() {return this.$socket}
    },
    methods:{
        loadRoom()
        {
            //TO-DO : charger le room correspondant au projet
            crService.getChatRoom(this.$auth.token(), this.$route.params.projectId)
            .then(chatRoom=>{

                let room = [{
                    roomId:chatRoom.uuid,
                    roomName: chatRoom.roomName,
                    users: [],
                    lastUpdated: chatRoom.lastUpdated,
                    avatar:"",
                    unreadCount: 0,
                    index:0,
                    typingUsers: [],
                }]

                chatRoom.users.forEach(user=>{
                    let newUser = {
                    _id:user,
                    username:user,
                    avatar:"",
                    }
                    room[0].users.push(newUser);
                })

                this.rooms = room
                this.currentRoom = this.rooms[0];
                this.loadingRooms = false;


                this.connectToChatServer();
            })            
        },

        fetchMessages() {
            this.messagesLoaded = false


            if(this.currentRoom)
            {
                this.pageMessage++;
                crService.getMessages(this.$auth.token(), this.pageMessage, this.messagesPerPage, this.currentRoom.roomId)
                .then(messages=>{
                        
                    
                    messages.forEach(message=>{
                        const formattedMessage = this.formatMessage(this.currentRoom.roomId, message)
                        
                        //On vérifie que le message n'est pas déjà affiché
                        const messageIndex = this.messages.findIndex(m => m._id === message._id)
                        if (messageIndex === -1) {
                            //this.messages = this.messages.concat([formattedMessage])
                            this.messages.unshift(formattedMessage)
                        } else {
                            this.$set(this.messages, messageIndex, formattedMessage)
                        }
                    })
                    
                    if(messages.length === 0)
                        this.messagesLoaded = true;
                })
            }''

        },

        async sendMessage({ content, roomId, file, replyMessage })
        {
            const message = {
                sender_id: this.currentUserId,
                content,
                timestamp: new Date()
            }

            if(file)
            {
                message.file = 
                {
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    extention: file.extention || file.type,
                    url: file.localUrl
                }
                if(file.audio)
                {
                    message.file.audio = true
                    message.file.duration = file.duration
                }
            }
            

                if(replyMessage)
                {
                    message.replyMessage = {
                        _id: replyMessage._id,
                        content: replyMessage.content,
                        sender_id: replyMessage.senderId,
                    }
                    if(replyMessage.file)
                    {
                        message.replyMessage.file = replyMessage.file
                    }
                }
                                
                var roomMessage = this.rooms.find(room => room.roomId === this.$route.params.projectId)
                

                //TO-DO ==> On enregistre le message en BDD avec le service
                //On envoie un socket puis
                crService.newMessage(this.$auth.token(),message,roomMessage.roomId)
                .then(newMessage => {
                    this.newMessage(newMessage, roomMessage)
                    this.socketChat.emit("sendMessage", newMessage, this.currentRoom.roomId)
                    if (file) {
                        this.uploadFile({ file, messageId: newMessage.uuid, roomId})
                    }
                }).catch(err =>{
                    console.log(err)
                })
                
                
                
                //Fonction pour stocker le message en BDD
                //On va plutôt utiliser un serveur de websocket pour envoyer le message
                //Pour ça on va utiliser le serveur de projet Vireed
                //const {id} = await messageRef(roomId).add(message)

                //Fonction d'upload du fichier
                //if (file) this.uploadFile({ file, messageId: id, roomId })
                
                //Fonction pour mettre à jour le champ "lastUpdated de la room en BDD"
                //roomsRef.doc(roomId).update({ lastUpdated: new Date() })
        },
        
		async uploadFile({ file, messageId, roomId }) {
			let type = file.extension || file.type
			if (type === 'svg' || type === 'pdf') {
				type = file.type
			}

            crService.uploadFile(this.$auth.token(), file, roomId, messageId)
            .then((message)=>{
                this.socketChat.emit("sendMessage", message, this.currentRoom.roomId)
                this.newMessage(message, roomId)
                
            })
		},

        newMessage(message, room)
        { 
            const formattedMessage = this.formatMessage(room, message)
            const messageIndex = this.messages.findIndex(m => m._id === message._id)
			if (messageIndex === -1) {
			    this.messages = this.messages.concat([formattedMessage])
			} else {
                this.$set(this.messages, messageIndex, formattedMessage)
			}
			//this.markMessagesSeen(room, message)            
        },

        //Danc cette fonction on met à jour le champs "seen du message"
        markMessagesSeen(room, message) {
			if (
				message.sender_id !== this.currentUserId &&
				(!message.seen || !message.seen[this.currentUserId])
			) {
                crService.updateSeenMessage(this.$auth.token(), message._id, this.currentRoom.roomId)
                .then(message=>{
                    this.socketChat.emit("sendMessage", message, this.currentRoom.roomId)
                    this.newMessage(message, roomId)
                })
			}
		},

		formatMessage(room, message) {

            const { sender_id, timestamp } = message
			var formatMessage = {
				...message,
				...{
					senderId: sender_id,
					_id: message._id,
					seconds: timestamp.seconds,
					timestamp: parseTimestamp(timestamp, 'HH:mm'),
					date: parseTimestamp(timestamp, 'DD MMMM YYYY'),
					username: sender_id,
					// avatar: senderUser ? senderUser.avatar : null,
					distributed: true,
				}
			}

            if(formatMessage.file)
            {
                formatMessage.file.url = "https://test.quanteec.com" + formatMessage.file.path
            }

            return formatMessage;
		},

        formatTimestamp(date, timestamp) {
			const timestampFormat = isSameDay(date, new Date()) ? 'HH:mm' : 'DD/MM/YY'
			const result = parseTimestamp(timestamp, timestampFormat)
			return timestampFormat === 'HH:mm' ? `Today, ${result}` : result
		},
       
        resetMessages() {
			this.messages = []
			this.messagesLoaded = false
			this.startMessages = null
			this.endMessages = null
            this.pageMessage=1
		},

        openFile({ message }) {
			window.open(message.file.url, '_blank')
		},

        connectToChatServer()
        {
            if(!this.socketChat)
            {
                this.socketChat = io(ws_chat_url, { path: ws_chat_path});

                this.socketChat.on("connect", () => {
                    console.log("Connecté au chat")
                    this.socketChat.emit("room", this.currentRoom.roomId)

                    //Une fois que l'on a rejoint une room on récupère les messages
                    this.socketChat.on("joined", ()=>{
                        this.fetchMessages();
                    })
                })

                this.socketChat.on("newMessage", (message, roomId)=>{
                    if(this.currentRoom.roomId === roomId) 
                    {
                        this.newMessage(message);  
                    }
                })                

                
            }
        },

        async sendMessageReaction({ reaction, remove, messageId, roomId }) {
            if(!remove)
            {
                crService.addReaction(this.$auth.token(), messageId, reaction.name, roomId)
                .then(newMessage=>{
                    this.newMessage(newMessage, roomId)
                    this.socketChat.emit("sendMessage", newMessage, roomId)
                })
            }else if (remove)
            {
                crService.removeReaction(this.$auth.token(), messageId, reaction.name, roomId)
                .then(newMessage=>{
                    this.newMessage(newMessage, roomId)
                    this.socketChat.emit("sendMessage", newMessage, roomId)
                })
            }
        },

        async editMessage({ messageId, newContent, roomId, file }) {
			const newMessage = { edited: new Date() }
			newMessage.content = newContent
			if (file) {
				newMessage.file = {
					name: file.name,
					size: file.size,
					type: file.type,
					extension: file.extension || file.type,
					url: file.url || file.localUrl
				}
				if (file.audio) {
					newMessage.file.audio = true
					newMessage.file.duration = file.duration
				}
			} else {
				newMessage.$unset = {file:true}
			}
                crService.editMessage(this.$auth.token(),newMessage,roomId, messageId)
                .then(newMessage => {
                    this.newMessage(newMessage, roomId)
                    this.socketChat.emit("sendMessage", newMessage, this.currentRoom.roomId)
                    if (file) {
                        this.uploadFile({ file, messageId: newMessage.uuid, roomId})
                    }
                }).catch(err =>{
                    console.log(err)
                })
		},

        async deleteMessage({ message, roomId }) {
            crService.deleteMessage(this.$auth.token(), message._id, roomId)
            .then(deletedMessage=>{
                this.newMessage(deletedMessage, roomId)
                this.socketChat.emit("sendMessage", deletedMessage, this.currentRoom.roomId)

            })
		},
    },
    mounted()
    {
        //Serveur de WS indépendant ==> Oui

        this.currentUserId = this.$auth.getMyUser().username,
        this.loadRoom();

        //this.updateuserOnlineStatus();
    },
  }
</script>